import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Faction } from './faction';
import { Type } from './type';

export class Aspect extends Node {
    public static _type: string = 'Aspect';
    public i_aspect: true = true;

    public graphqlType?: string;
    public data: any;

    public constructor(source?: any) {
        super(source);

        if (source) {
            this.graphqlType = source.graphqlType;
            this.data = source.data;
        }
    }

    public copy(source: any) {
        super.copy(source);

        if (source) {
            this.graphqlType = source.graphqlType;
            this.data = source.data;
        }
    }

    public get model(): any {
        const rest = super.model;
        if (rest.data) {
            const data: any = {};
            for (let key in rest.data) {
                const { type, ...value } = rest.data[key];
                if (type.data.interface?.length) {
                    value.interface = {
                        id: type.data.interface,
                        multiple: type.data.max != 1,
                    }
                }
                data[key] = value;
            }
            rest.data = data;
        }
        return rest;
    }

    public override load(source?: any): void {
        this.copy(source);

        if (this.data) {
            for (let key in this.data) {
                const { type, ...value } = this.data[key];
                this.data[key] = { type: new Type(type), ...value };
            }
        }
    }

    public override fit(branch: Branch): boolean {
        return branch instanceof Faction;
    }
}
